import { DashboardScreen } from './dashboard';
import { ApplicationOnboardingScreen } from './application-onboarding';
import { ApplicationReviewScreen } from './application-review';
import { CoachAppointmentsScreen, CoachInstantMeetingsScreen, CoachPastMeetingsScreen, CoachMeetCompletedScreen, CoachStudents, CoachStudentDetails, CoachPastMeetingsDetailV2 } from './coach';
import * as GotIt from './got-it';
import RecurringCalendar from '@/screens/coach/appointments/RecurringCalendar.tsx';
import Profile from './profile';
import LoginScreen from './login';
import CreateAccountScreen from './create-account';
import MeetConnectionTestScreen from './common/meet-connection-test';
import Messages from './messages';
import NotificationsScreen from '@/screens/notifications';
import Landing from '@/screens/landing';
import { SolveQuestionScreen, SolverWhiteBoard, SolverQuestionsAnsweredScreen, SolverExpertReviewScreen, SolverResolveQuestionsScreen } from '@/screens/solver';
import DeleteAccountScreen from '@/screens/delete-account';
import MeetProviderTest from '@/components/meet-provider-test';
import { SupportDocumentsScreen } from '@/screens/support-documents';
import { BoutiqueClassroomScreen } from '@/screens/boutique-classroom';
import { BoutiqueStudentsScreen } from '@/screens/boutique-classroom/students';

export default {
	DashboardScreen,
	ApplicationReviewScreen,
	ApplicationOnboardingScreen,
	CoachAppointmentsScreen,
	CoachInstantMeetingsScreen,
	CoachPastMeetingsScreen,
	RecurringCalendar,
	GotIt,
	Profile,
	CoachMeetCompletedScreen,
	CoachPastMeetingsDetailV2,
	CoachStudents,
	CreateAccountScreen,
	LoginScreen,
	MeetConnectionTestScreen,
	Messages,
	NotificationsScreen,
	Landing,
	SolveQuestionScreen,
	SolverWhiteBoard,
	SolverQuestionsAnsweredScreen,
	SolverExpertReviewScreen,
	SolverResolveQuestionsScreen,
	CoachStudentDetails,
	DeleteAccountScreen,
	MeetProviderTest,
	SupportDocumentsScreen,
	BoutiqueClassroomScreen,
	BoutiqueStudentsScreen
};
